import FormSection from '@/components/Forms/FormSection';
import { Box } from '@palmetto/palmetto-components';

import {
  GeothermalInstallPackageFileCategory,
  InstallationPackagePhotoCategory,
  ProgramType,
  RequirementFlagSettingsType,
} from 'types';

import { PhotosList } from '../Documents/PhotosList';

export const InstallPhotos = ({
  showCheckboxes,
  checkboxCategories,
}: {
  showCheckboxes: boolean;
  checkboxCategories: GeothermalInstallPackageFileCategory[];
}) => {
  return (
    <FormSection
      title="Installation Documents & Photos"
      description={
        <Box>
          Upload all documents and photos collected during the system installation. These must include the Equipment
          Data Plate, Mechanical Room Wide Shot, Flow Center, Loop Field Photo, Electrical Disconnect, and Thermostat
          photos.
        </Box>
      }
    >
      <PhotosList
        title="Geothermal Installation Photos"
        description="Upload all installation documentation and photos"
        category={InstallationPackagePhotoCategory.geothermalInstallationPhotos}
        baseCategory="Installation Photo Documentation"
        flagType={RequirementFlagSettingsType.geothermalInstallationPhotos}
        showCheckboxes={showCheckboxes}
        checkboxCategories={checkboxCategories}
        programType={ProgramType.geothermal}
      />
    </FormSection>
  );
};
